// removed by extract-text-webpack-plugin
module.exports = {"this":"ShortcodeEmoji__this___34WxU Emoji__this___2hD4_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/ShortcodeEmoji.css
// module id = 999
// module chunks = 4